// 校验邮箱
export function validate_email(value) {
  let regEmail = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/;
  return regEmail.test(value);
}

// 校验密码
export function validate_password(value) {
  let regPassword = /^(?!\D+$)(?![^a-zA-Z]+$)\S{6,20}$/;
  return regPassword.test(value);
}

// 校验验证码
export function validate_code(value) {
  let regCode = /^[a-z0-9]{6}$/;
  return regCode.test(value);
}

export function validate_username(value){
  let regUsername = /^[a-z0-9_-]{3,15}$/
  return regUsername.test(value);
}

export function validate_keyword(value){
  let regKeyword = /^[\u4e00-\u9fa50-9A-Za-z]{1,20}$/
  return regKeyword.test(value);
}